// Runtime configuration. Nothing here is secret: the Entra client ID is public by design.
const trimSlash = (s: string) => s.replace(/\/+$/, "");

/** API origin. Empty string means same origin, which is how vd-server serves the console. */
export const API_BASE = trimSlash(import.meta.env.VITE_VD_API_BASE ?? "");

/** Vertec Voice Entra app registration (multi-tenant SPA). Override with VITE_VD_ENTRA_CLIENT_ID. */
export const ENTRA_CLIENT_ID: string =
  import.meta.env.VITE_VD_ENTRA_CLIENT_ID || "636e6a75-a169-43cc-b8cb-b13d229e8736";

/** Dev sign-in is compiled in only for dev servers and mock builds. */
export const DEV_SIGNIN_ENABLED = import.meta.env.DEV || import.meta.env.MODE === "mock";

export function wsUrl(path: string): string {
  const base = API_BASE || window.location.origin;
  const u = new URL(path, `${base}/`);
  u.protocol = u.protocol === "https:" ? "wss:" : "ws:";
  return u.toString();
}

export const APP_VERSION = "0.1.0";
